import dayjs from 'dayjs'
import React from 'react'
import { useUpdateLog } from 'utils/log'

import CalendarLine from '../items/CalendarLine'
import { FormTitleProps } from '../items/FormTitle'
import BaseGroup from './BaseGroup'

/**
 * 対象がCalendarGroupProps型かチェックする
 * @param target チェック対象
 */
export const isCalendarGroupProps = (
  target: any
): target is CalendarGroupProps => {
  return target.calendar !== undefined && target.title !== undefined
}

/**
 * カレンダーグループ
 */
const CalendarGroup: React.FC<CalendarGroupProps> = (props) => {
  const { selectedDate, onChanged } = props

  useUpdateLog(
    props.title,
    {
      title: props.title,
      isRequired: props.isRequired,
      selected: props.selectedDate,
      minDate: props.minDate,
      maxDate: props.maxDate,
    },
    [props]
  )

  const handleDateChanged = (date: dayjs.Dayjs): void => {
    onChanged && onChanged(date)
  }

  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      <CalendarLine
        selectedDate={selectedDate}
        selectDate={handleDateChanged}
        minDate={props.minDate}
        maxDate={props.maxDate}
      />
    </BaseGroup>
  )
}

/** CalendarGroupPropsのtype定義 */
export type CalendarGroupProps = FormTitleProps & {
  /** 選択した予約日 */
  selectedDate: dayjs.Dayjs
  /** フォーム名 */
  formName: string
  /** 最小日付 */
  minDate?: dayjs.Dayjs
  /** 最大日付 */
  maxDate?: dayjs.Dayjs
  /** 日付変更時のコールバック */
  onChanged?: (date: dayjs.Dayjs) => void
}

export default React.memo<CalendarGroupProps>(CalendarGroup)
